<template>
  <div>
    <input-text class="bg-white" placeholder="Pesquisar pessoa por nome" v-model="filtro">
    </input-text>
    <div class="row px-2">
      <vue-perfect-scrollbar class="">
        <b-table-simple
          hover
          small
          caption-top
          :style="`width:calc(700px + ${115 * mesesDepesas.length}px)`"
        >
          <b-thead head-variant="dark">
            <b-tr>
              <b-th v-if="controles"></b-th>
              <b-th>Nome</b-th>
              <b-th>Função</b-th>
              <b-th>Valor hora</b-th>
              <b-th>Horas alocadas</b-th>
              <b-th>Valor total</b-th>
              <b-th
                v-if="table.itens.find((el) => el.edit)"
                class="horasFixas"
                style="
                  background: linear-gradient(to bottom, #90caf9, #047edf) !important;
                "
                >Horas fixas</b-th
              >
              <b-th v-for="mes in mesesDepesas" :key="mes.text">{{ mes.text }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="rh in table.itens.filter((el) =>
                el.pessoa.nome.toLowerCase().includes(filtro.toLowerCase())
              )"
              :key="rh.id"
            >
              <b-td style="width: 100px" v-if="controles">
                <div class="d-flex">
                  <b-button
                    v-if="!rh.edit && !esconderEditar"
                    variant="flat-secondary"
                    @click="rh.edit = true"
                  >
                    <i class="fa-solid fa-edit"></i>
                  </b-button>
                  <b-button
                    v-if="rh.edit"
                    variant="flat-success"
                    @click="$emit('atualizar', rh)"
                  >
                    <i class="fa-solid fa-check"></i>
                  </b-button>
                  <b-button
                    v-if="rh.edit"
                    variant="flat-secondary"
                    @click="rh.edit = false"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </b-button>
                  <b-button
                    v-if="!rh.edit && !esconderExcluir"
                    variant="flat-danger"
                    @click="$emit('deletar', rh)"
                  >
                    <i class="fa-solid fa-trash"></i>
                  </b-button>
                  <div class="align-itens-center" v-if="false">
                    <b-badge
                      class="pointer"
                      v-if="!rh.edit"
                      @click="$emit('baixarHH', rh.id)"
                    >
                      <i class="fas fa-cloud-download mr-2"></i>
                      Baixar HH
                    </b-badge>
                  </div>
                </div>
              </b-td>
              <b-td style="width: 250px">{{ rh.pessoa.nome }}</b-td>
              <b-td style="min-width: 250px">
                <input-select
                  no-label
                  v-if="rh.edit"
                  label="Função"
                  :options="options.funcao"
                  v-model="rh.funcao"
                  class="input__no_margin bg-white"
                  :ref="`tabela-${rh.id}-funcao`"
                  required
                />
                <span v-if="!rh.edit">
                  {{ formatarFuncao(rh.funcao) }}
                </span>
              </b-td>
              <b-td style="min-width: 150px">
                <input-money
                  class="input__no_margin bg-white"
                  v-if="rh.edit"
                  v-model="rh.valorHora"
                  :ref="`tabela-${rh.id}-valor`"
                  @input="validarValor(rh)"
                  :min="0"
                />
                <span v-if="!rh.edit">{{ rh.valorHora }}</span>
              </b-td>
              <b-td style="width: 200px">{{
                rh.horasSazonais.reduce((total, hora) => total + parseInt(hora.horas), 0)
              }}</b-td>
              <b-td style="width: 150px">{{
                formatarValor(
                  removerValor(rh.valorHora ? rh.valorHora + "" : "0") *
                    rh.horasSazonais.reduce(
                      (total, hora) => total + parseInt(hora.horas),
                      0
                    )
                )
              }}</b-td>
              <b-td
                style="min-width: 150px"
                class="horasFixas"
                v-if="table.itens.find((el) => el.edit)"
              >
                <input-text
                  v-if="rh.edit"
                  class="input__no_margin bg-white"
                  type="number"
                  v-model="rh.horasFixas"
                  :min="0"
                  :max="176"
                  @input="atualizarHoras(rh)"
                />
              </b-td>
              <b-td
                style="width: 100px"
                v-for="(mes, i) in mesesDepesas"
                :key="mes.value"
              >
                <input-text
                  type="number"
                  class="input__no_margin bg-white"
                  v-if="rh.edit"
                  v-model="getHorasSazonais(rh, mes.value).horas"
                  :min="0"
                  :max="176"
                  :ref="`tabela-${rh.id}-horas-${i}`"
                />
                <span v-if="!rh.edit">{{ getHorasSazonais(rh, mes.value).horas }}</span>
              </b-td>
            </b-tr>

            <b-tr variant="warning">
              <b-td :colspan="controles ? 4 : 3">Total</b-td>
              <b-td style="width: 150px">{{ totalHoras }}</b-td>
              <b-td style="width: 150px">{{ totalValor }}</b-td>
              <b-td class="horasFixas" v-if="table.itens.find((el) => el.edit)"></b-td>
              <b-td v-for="(hora, i) in horasSazonais" :key="i">
                {{ hora.horas }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputMoney from "@/components/inputs/InputMoney";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import helpers from "@/common/utils/helpers";

import cloneDeep from "lodash/cloneDeep";

export default {
  components: {
    InputText,
    InputMoney,
    VuePerfectScrollbar,
    InputSelect,
  },
  props: {
    duracao: {
      default: 0,
    },
    itens: {
      default: () => [],
    },
    controles: {
      type: Boolean,
      default: false,
    },

    esconderEditar: {
      type: Boolean,
      default: false,
    },
    esconderExcluir: {
      type: Boolean,
      default: false,
    },
    realizada: {
      type: Boolean,
      default: false,
    },
    projeto: {
      default: {},
    },
  },
  data: () => ({
    filtro: "",
    table: {
      itens: [],
    },
    options: {
      funcao: helpers.getFuncoes(),
    },
  }),
  watch: {
    itens: {
      handler: function () {
        this.table.itens = cloneDeep(this.itens).map((el) => {
          el.valorHora = helpers.formatarValor(el.valorHora || 0);
          el.edit = false;
          el.horasFixas = 0;
          return el;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getHorasSazonais: function (rh, mes) {
      let horas = rh.horasSazonais.find((hora) => hora.mes == mes);
      if (horas) return horas;

      rh.horasSazonais.push({
        mes: mes,
        horas: 0,
      });

      return this.getHorasSazonais(rh, mes);
    },

    formatarFuncao: function (v) {
      if (v != "SemFuncao") {
        return helpers.getEnum(v).text;
      } else {
        return "";
      }
    },

    formatarValor: function (v) {
      if (v) {
        return helpers.formatarValor(v);
      } else {
        return helpers.formatarValor(0);
      }
    },

    removerValor: function (v) {
      return helpers.removerValor(v);
    },

    atualizarHoras: function (rh) {
      if (rh.horasFixas < 0) rh.horasFixas = 0;
      if (rh.horasFixas > 176) rh.horasFixas = 176;
      rh.horasSazonais.forEach((hora) => {
        hora.horas = rh.horasFixas;
      });
    },

    validarValor: function (rh) {
      if (!parseInt(rh.valorHora.substring(3)) || parseInt(rh.valorHora.substring(3)) < 0)
        rh.valorHora = "";
    },
  },
  computed: {
    quantidadeMeses: function () {
      const duracao = parseInt(this.duracao, 10) || 0;
      if (!this.projeto.dataInicio) return duracao;
      const dataFimProjeto = this.projeto.dataConclusao || this.projeto.dataTermino;
      if (!dataFimProjeto) return duracao;

      let mesInicio = parseInt(helpers.formatarData(this.projeto.dataInicio, "MM"), 10);
      let anoInicio = parseInt(helpers.formatarData(this.projeto.dataInicio, "YYYY"), 10);
      let mesFim = parseInt(helpers.formatarData(dataFimProjeto, "MM"), 10);
      let anoFim = parseInt(helpers.formatarData(dataFimProjeto, "YYYY"), 10);

      if (
        Number.isNaN(mesInicio) ||
        Number.isNaN(anoInicio) ||
        Number.isNaN(mesFim) ||
        Number.isNaN(anoFim)
      ) {
        return duracao;
      }

      let total = (anoFim - anoInicio) * 12 + (mesFim - mesInicio) + 1;
      if (total <= 0) return duracao;
      return total;
    },
    mesesDepesas: function () {
      let meses = [];
      if (!this.projeto.dataInicio) return [];
      let mes = parseInt(helpers.formatarData(this.projeto.dataInicio, "MM"), 10);
      let ano = parseInt(helpers.formatarData(this.projeto.dataInicio, "YYYY"), 10);
      for (let index = 0; index < this.quantidadeMeses; index++) {
        meses.push({
          value: index,
          text: this.realizada
            ? `${helpers.retornarNomeMes(mes)}/${ano}`
            : `Mês ${index + 1}`,
        });
        mes++;
        if (mes > 12) {
          mes = 1;
          ano++;
        }
      }
      return meses;
    },

    horasSazonais: function () {
      let horas = [];
      for (let index = 0; index < this.quantidadeMeses; index++) {
        let quantidade = 0;
        this.table.itens.forEach((element) => {
          quantidade += parseInt(
            element.horasSazonais.find((el) => el.mes == index)
              ? element.horasSazonais.find((el) => el.mes == index).horas
              : "0"
          );
        });
        horas.push({
          mes: index,
          horas: quantidade,
        });
      }
      return horas;
    },

    valorPessoa: function () {
      return this.table.itens.reduce(
        (total, pessoa) =>
          total +
          (pessoa.valorHora ? parseInt(helpers.removerValor(pessoa.valorHora)) : 0),
        0
      );
    },

    totalHoras: function () {
      return this.horasSazonais.reduce((total, hora) => total + parseInt(hora.horas), 0);
    },

    totalValor: function () {
      return helpers.formatarValor(
        this.table.itens.reduce((total, pessoa) => {
          return (
            total +
            pessoa.horasSazonais.reduce(
              (total, hora) => total + parseInt(hora.horas),
              0
            ) *
              helpers.removerValor(pessoa.valorHora)
          );
        }, 0)
      );
    },
  },
};
</script>
<style>
td.horasFixas {
  background: #90caf9;
  border-top: 1px solid #5f8eb5;
}
</style>
